import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { loadAllBoards, resetErrorMessage } from '../actions/projects';
import ProjectMain from '../../app-projects/project-main';
import Projects from '../../../../api/api-projects';
import { NotificationBanner } from '../../elements-banner/notification-banner';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ProjectsContainer extends Component {
  constructor (props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.inviteSave = this.inviteSave.bind(this);
    this.inviteSaveCb = this.inviteSaveCb.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    const { accessToken, profile } = this.props;
    if (profile.isFetching) {
      const SSOid = nextProps.profile.SSOid;
      this.props.loadAllBoards(SSOid, accessToken);
    }
  }

  inviteSave (projectId, payload, callback) {
    const { accessToken } = this.props;
    Projects.createInvites(accessToken, projectId, payload, callback);
  }

  inviteSaveCb () {
    // Render success banner
    const bannerMessage = () => {
      return (
        <ul className="text-center list-inline">
          <li>
            <i className="ico icon-yes"></i>
          </li>
          <li>
            <FormattedMessage
              id="boards.projects_container.invite_sent"
              defaultMessage="Your invite was sent"
            />
          </li>
        </ul>
      );
    };
    this.closeModal();
    return ReactDOM.render(
      <SharedIntlProviderHOC>
        <NotificationBanner
          showClose
          timing={4.6}
          message={bannerMessage()}
        />
      </SharedIntlProviderHOC>, document.getElementById('banner-container'));
  }

  closeModal () {
    $('#modal-container').modal('hide');
    return ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
  }

  render () {
    const { isFetching } = this.props;
    return (
      <div>
        {
          isFetching
            ? null
            : <ProjectMain
              {...this.props}
              closeModal={this.closeModal}
              inviteSave={this.inviteSave}
              inviteSaveCb={this.inviteSaveCb}
            />
        }
      </div>
    );
  }
}

ProjectsContainer.propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  accessToken: PropTypes.string.isRequired
};

function mapStateToProps (state) {
  const { auth, entities, profile, errors } = state;
  const { projects } = entities;
  const { accessToken } = auth;
  const isFetching = profile.isFetching || entities.isFetching;

  return {
    accessToken,
    profile,
    projects,
    isFetching,
    errors
  };
}

export default connect(mapStateToProps, {
  loadAllBoards,
  resetErrorMessage
})(ProjectsContainer);
